import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/tarea/importer/tareaImporterActions';

export default importerReducers(actions);
